import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";

var _dec, _class;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import numberArrayGenerator from 'number-array-generator';
import { changeConnectionValue, getReachEstimate } from 'redux/modules/audience';
import * as _ from 'lodash';
import { RadioButton, RadioButtonGroup } from 'material-ui/RadioButton';
import * as styles from './Audiences.scss';
var AudienceConnection = (_dec = connect(function (state) {
  var orgId = state.organization.current.id;
  return {
    audience: state.audience,
    targetingConfigData: state.audience.FacebookTargetingConfig.data,
    adAccount: state.ads.adAccount && state.ads.adAccount[orgId] ? state.ads.adAccount[orgId] : null,
    organization: state.organization.current,
    theme: state.theme
  };
}, {
  changeConnectionValue: changeConnectionValue,
  getReachEstimate: getReachEstimate
}), _dec(_class = /*#__PURE__*/function (_Component) {
  _inherits(AudienceConnection, _Component);

  var _super = _createSuper(AudienceConnection);

  function AudienceConnection() {
    _classCallCheck(this, AudienceConnection);

    return _super.apply(this, arguments);
  }

  _createClass(AudienceConnection, [{
    key: "render",
    value: function render() {
      var _this = this;

      var selectedValue = 'all';

      if (this.props.targetingConfigData.flexible_spec[0].connections.length) {
        selectedValue = 'fans';
      } else if (this.props.targetingConfigData.flexible_spec[0].friends_of_connections.length) {
        selectedValue = 'friends+fans';
      } else if (this.props.targetingConfigData.excluded_connections && this.props.targetingConfigData.excluded_connections.length) {
        selectedValue = 'nofans';
      }

      return /*#__PURE__*/React.createElement("div", {
        className: "row",
        style: {
          marginTop: 30
        }
      }, /*#__PURE__*/React.createElement("div", {
        className: "col-xs-12 col-sm-4"
      }, /*#__PURE__*/React.createElement("h5", {
        className: styles.connectionsLabel
      }, "Connections to your page")), /*#__PURE__*/React.createElement("div", {
        className: "col-xs-12 col-sm-8"
      }, /*#__PURE__*/React.createElement(RadioButtonGroup, {
        valueSelected: selectedValue,
        onChange: function onChange(e, val) {
          _this.props.changeConnectionValue(val, _this.props.adAccount.facebookPageId);
        },
        style: {
          width: '100%'
        },
        name: "page-connection",
        className: "form-control"
      }, /*#__PURE__*/React.createElement(RadioButton, {
        label: "No preference",
        value: "all"
      }), /*#__PURE__*/React.createElement(RadioButton, {
        label: "Fans of the page",
        value: "fans"
      }), /*#__PURE__*/React.createElement(RadioButton, {
        label: "Friends of fans of the page",
        value: "friends+fans"
      }), /*#__PURE__*/React.createElement(RadioButton, {
        label: "Non-fans of the page",
        value: "nofans"
      }))));
    }
  }]);

  return AudienceConnection;
}(Component)) || _class);
export { AudienceConnection as default };
AudienceConnection.defaultProps = {
  specIndex: 0
};